(function () {
  'use strict';
  if (window.hjCollectionPdpModalLoaded) return;
  window.hjCollectionPdpModalLoaded = true;
  var dialog = document.querySelector('[data-hj-collection-pdp-modal]');
  if (!dialog) return;
  var heading = dialog.querySelector('[data-hj-pdp-title]');
  var status = dialog.querySelector('[data-hj-pdp-status]');
  var retry = dialog.querySelector('[data-hj-pdp-retry]');
  var container = dialog.querySelector('[data-hj-pdp-content]');
  function hydrateLandingDelivery(root, sourceDocument) {
    var source = sourceDocument.querySelector('.hj__timeline-section .hj__timeline-step:last-child .hj__timeline-date');
    var atc = root.querySelector('[data-atc-button]');
    if (!source || !atc) return;
    var value = source.textContent.trim();
    var dynamic = source.dataset.hjDate === 'arrive';
    if (!dynamic && (!value || value === '—')) return;
    var strip = root.querySelector('[data-pdp-delivery]');
    if (!strip) {
      strip = root.ownerDocument.createElement('div');
      strip.className = 'hj-pdp-delivery';
      strip.dataset.pdpDelivery = '';
      strip.innerHTML = "<span class=\"hj-pdp-delivery__step\"> <span class=\"hj-pdp-delivery__label\">Order</span> <strong class=\"hj-pdp-delivery__date\">Today</strong> </span> <span class=\"hj-pdp-delivery__track\" aria-hidden=\"true\"><span class=\"hj-pdp-delivery__fill\"></span></span> <span class=\"hj-pdp-delivery__step\"> <span class=\"hj-pdp-delivery__label\">Print</span> <strong class=\"hj-pdp-delivery__date\">Tomorrow</strong> </span> <span class=\"hj-pdp-delivery__track hj-pdp-delivery__track--last\" aria-hidden=\"true\"><span class=\"hj-pdp-delivery__fill\"></span></span> <span class=\"hj-pdp-delivery__step\"> <span class=\"hj-pdp-delivery__label\">Est. arrival</span> <strong class=\"hj-pdp-delivery__date\" data-pdp-delivery-date></strong> </span>";
      atc.before(strip);
    }
    var date = strip.querySelector('[data-pdp-delivery-date]');
    date.textContent = value;
    if (dynamic) {
      date.dataset.hjDate = 'arrive';
      date.dataset.hjDays = source.dataset.hjDays || '5';
    }
    strip.hidden = false;
  }
  function syncLandingOptionLabels(root, current) {
    root.querySelectorAll('[data-pdp-option-value]').forEach(function (node) {
      node.textContent = (current.options || [])[Number(node.dataset.pdpOptionValue)] || '';
    });
  }
  var closeButton = dialog.querySelector('[data-hj-pdp-close]');
  var hostHeader = heading.parentElement;
  hostHeader.classList.add('hj__flow-header');
  var hostSteps = document.createElement('ol');
  hostSteps.dataset.hjHostSteps = '';
  hostSteps.setAttribute('aria-label', 'Personalization progress');
  ['Photo', 'Details', 'Preview'].forEach(function (label, index) {
    var item = document.createElement('li');
    item.dataset.hostStep = String(index + 1);
    item.innerHTML = '<span class="hj__flow-number">' + (index + 1) + '</span><span>' + label + '</span>';
    hostSteps.appendChild(item);
  });
  hostHeader.insertBefore(hostSteps, heading);
  closeButton.textContent = '×';
  closeButton.setAttribute('aria-label', 'Close personalization');
  function syncHostSteps() {
    var current = container.querySelector('.hj-step.active');
    var step = current ? Number(current.dataset.step) : 1;
    hostSteps.querySelectorAll('[data-host-step]').forEach(function (item) {
      var value = Number(item.dataset.hostStep);
      item.classList.toggle('is-done', value < step);
      if (value === step) item.setAttribute('aria-current', 'step');
      else item.removeAttribute('aria-current');
    });
  }
  new MutationObserver(syncHostSteps).observe(container, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-step']
  });
  syncHostSteps();
  var fallback = document.createElement('a');
  fallback.dataset.hjPdpFallback = '';
  fallback.className = 'hj__button hj__button--secondary';
  fallback.textContent = 'Continue on product page';
  fallback.hidden = true;
  dialog.insertBefore(fallback, container);
  var legacyAssets;
  var legacyStyles = [];
  function loadAsset(url, css) {
    return new Promise(function (resolve, reject) {
      if (!url) return reject(new Error('Missing workflow asset'));
      var element = document.createElement(css ? 'link' : 'script');
      if (css) { element.rel = 'stylesheet'; element.href = url; legacyStyles.push(element); }
      else element.src = url;
      var timer = setTimeout(function () { reject(new Error('Workflow asset timeout')); }, 30000);
      element.onload = function () {
        clearTimeout(timer);
        if (css) element.disabled = !(active && active.legacy && dialog.open);
        resolve();
      };
      element.onerror = function () { clearTimeout(timer); element.remove(); reject(new Error('Workflow asset unavailable')); };
      document.head.appendChild(element);
    });
  }
  function ensureLegacy() {
    if (!legacyAssets) {
      legacyAssets = Promise.all([
        loadAsset(dialog.dataset.legacyCss, true),
        loadAsset(dialog.dataset.legacyProductCss, true),
        loadAsset(dialog.dataset.legacyCoreCss, true),
        window.HavjoyCore ? Promise.resolve() : loadAsset(dialog.dataset.legacyCoreSrc),
        loadAsset(dialog.dataset.legacyScopeSrc),
        loadAsset(dialog.dataset.legacyProductSrc),
        loadAsset(dialog.dataset.legacyTeeSrc)
      ]).then(function () {
        // A downloaded script is not enough: only cache a usable legacy runtime.
        // Keeping this check here also allows Retry to recover from core failures.
        if (!window.HavjoyCore) throw new Error('PDP core unavailable');
      }).catch(function (error) { legacyAssets = null; throw error; });
    }
    return legacyAssets;
  }
  var entries = new Map();
  var active, opener, previousOverflow;
  function setEntryActive(entry, value) {
    var scope = entry && entry.content && entry.content.querySelector('.hj-personalize-scope');
    if (!scope) return;
    scope.dataset.hjCollectionActive = String(value);
    if (value) scope.dispatchEvent(new CustomEvent('havjoy:collection-activated'));
  }

  function render(entry) {
    if (active !== entry || !dialog.open) return;
    status.textContent = entry.error ? 'We could not load this product. Please try again.' : (entry.ready ? '' : 'Loading product…');
    status.hidden = entry.ready;
    retry.hidden = !entry.error;
    fallback.hidden = !entry.error;
    fallback.href = entry.url;
    legacyStyles.forEach(function (style) { style.disabled = !entry.legacy; });
    if (entry.ready) {
      container.replaceChildren(entry.content);
      setEntryActive(entry, true);
      if (!entry.initialized) {
        if (entry.legacy) {
          var scopedDocument = window.HjLegacyScope(entry.content);
          window.HavjoyPersonalizeProductInit(scopedDocument);
          window.HavjoyTeeTemplateInit(scopedDocument);
          // The gallery's hidden Edit button also has upload-trigger. Opening it
          // marks this as editingGenerated and suppresses the purchase handoff.
          var upload = entry.content.querySelector('.upload-trigger[data-show-when="initial"]');
          if (upload) upload.click();
        } else window.HavjoyTemplateFlowV2.init(entry.content.querySelector('[data-hjv2-root]'));
        entry.initialized = true;
        document.dispatchEvent(new CustomEvent('havjoy:pdp-mounted'));
      }
    }
  }

  async function load(entry) {
    entry.error = false;
    entry.loading = true;
    render(entry);
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 30000);
    try {
      var response = await fetch(entry.url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('PDP unavailable');
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var main = doc.querySelector('#MainContent .hj-personalize-scope');
      entry.legacy = !!(main && !main.querySelector('[data-hjv2-root]') && main.querySelector('#tee-form'));
      if (entry.legacy) {
        if (dialog.dataset.requireV8 === 'true') throw new Error('This product requires its product page');
        await ensureLegacy();
        if (!window.HavjoyCore) throw new Error('PDP core unavailable');
      } else if (!main || !main.querySelector('[data-hjv2-root]') || !window.HavjoyTemplateFlowV2) throw new Error('PDP unavailable');
      // Mount markup and JSON only. Never execute scripts from fetched HTML.
      main.querySelectorAll('script').forEach(function (script) {
        if (script.type !== 'application/json') script.remove();
      });
      if (entry.legacy) main.dataset.hjLegacyFlow = 'true';
      else main.dataset.hjCollectionFlow = 'true';
      // Keep only the workflow and purchase controls, not the PDP presentation.
      main.querySelectorAll('.hj-tee-info__mobile-header,.hj-tee-info__title,.hj-tee-info__rating,.hj-tee-desc,.hj-tee-cutoff,.hj-modal-headline-wrap').forEach(function (node) { node.remove(); });
      hydrateLandingDelivery(main, doc);
      var nestedDialog = main.querySelector('#personalize-modal');
      if (entry.legacy) window.HjLegacyPanel(main);
      if (!entry.legacy) {
      var stepPanel = doc.createElement('div');
      stepPanel.id = 'personalize-modal';
      stepPanel.className = 'personalize-modal';
      stepPanel.setAttribute('aria-label', 'Personalization steps');
      stepPanel.append.apply(stepPanel, Array.from(nestedDialog.childNodes));
      stepPanel.querySelectorAll('[data-close]').forEach(function (button) { button.hidden = true; });
      nestedDialog.replaceWith(stepPanel);
      main.querySelector('.hj-tee-product').hidden = true;
      }
      entry.content = document.createElement('div');
      entry.content.appendChild(main);
      entry.content.addEventListener('havjoy:pdp-purchase-state', function (event) {
        syncLandingOptionLabels(main, event.detail);
      });
      entry.content.addEventListener('havjoy:pdp-unavailable', function () {
        entry.ready = false;
        entry.initialized = false;
        entry.error = true;
        if (active === entry) container.replaceChildren();
        render(entry);
      });
      entry.ready = true;
      render(entry);
    } catch (error) {
      entry.ready = false;
      entry.error = true;
      if (active === entry) container.replaceChildren();
      render(entry);
    } finally {
      clearTimeout(timer);
      entry.loading = false;
    }
  }

  function show(url, title) {
    if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
    url.searchParams.delete('view');
    if (window.Shopify && Shopify.theme && Shopify.theme.id) url.searchParams.set('preview_theme_id', Shopify.theme.id);
    // Detach inactive DOM: preserve state and pending jobs, avoid duplicate IDs.
    setEntryActive(active, false);
    container.replaceChildren();
    var entry = entries.get(url.pathname);
    if (!entry) {
      entry = { url: url.href, ready: false, initialized: false, loading: false };
      entries.set(url.pathname, entry);
    }
    active = entry;
    heading.textContent = title;
    if (!dialog.open) {
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    }
    if (!entry.ready && !entry.loading) load(entry);
    else render(entry);
    container.scrollTop = 0;
    closeButton.focus();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('button[data-hj-pdp-modal-url]');
    if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (trigger.disabled) return;
    var url = new URL(trigger.dataset.hjPdpModalUrl, location.href);
    if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
    event.preventDefault();
    opener = trigger;
    show(url, trigger.dataset.productTitle || 'Personalize your tee');
  });
  closeButton.addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('havjoy:pdp-cart-added', function () { dialog.close(); });
  dialog.addEventListener('close', function (event) {
    if (event.target !== dialog) return;
    setEntryActive(active, false);
    document.documentElement.style.overflow = previousOverflow || '';
    legacyStyles.forEach(function (style) { style.disabled = true; });
    if (opener && opener.isConnected) opener.focus();
  });
  retry.addEventListener('click', function () { if (active && !active.loading && !active.ready) load(active); });
})();
